import React, { useCallback, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SnakShell } from '../SnakShell';
import { SnakStepView } from './SnakStepView';
import { introOrder } from '../../data/products';
import { TOTAL_STEPS, toneForStep } from '../../utils/snakSteps';
import type { SiblingRole } from '../../types/snak';
interface SnakExperienceProps {
  /** Show the step progress rail in the header. */
  showProgress?: boolean;
  /** Let the "Families are funny" interlude play itself, or require a tap per line. */
  autoplayInterlude?: boolean;
}

/**
 * The full mobile Snak. Sized by its container, so it can live inside a
 * phone frame on the presentation shell.
 */
export function SnakExperience({
  showProgress = true,
  autoplayInterlude = true
}: SnakExperienceProps) {
  const [step, setStep] = useState(0);
  const [role, setRole] = useState<SiblingRole | null>(null);
  const [interludeDark, setInterludeDark] = useState(false);
  const [order, setOrder] = useState(() => introOrder());
  const next = useCallback(() => setStep(s => Math.min(s + 1, TOTAL_STEPS - 1)), []);
  const back = useCallback(() => {
    setStep(s => {
      const target = Math.max(s - 1, 0);
      if (target === 0) setRole(null);
      if (target <= 2) setInterludeDark(false);
      return target;
    });
  }, []);
  const chooseRole = (picked: SiblingRole) => {
    if (role) return;
    setRole(picked);
    window.setTimeout(() => setStep(1), 620);
  };
  const restart = () => {
    setRole(null);
    setInterludeDark(false);
    setOrder(introOrder());
    setStep(0);
  };
  return <SnakShell tone={toneForStep(step, interludeDark)} step={step} total={TOTAL_STEPS} showProgress={showProgress} canBack={step > 0} canForward={step < TOTAL_STEPS - 1} onBack={back} onForward={next} onReplay={restart} data-id="element-78" data-mp="3w4u6sz2sy078">
      <AnimatePresence mode="wait" data-id="element-79" data-mp="1zbik6sqfrnll">
        <motion.div key={step} initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -14
      }} transition={{
        duration: 0.45,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex flex-1 flex-col" data-id="element-80" data-mp="1zahaosp2j95z">
          <SnakStepView step={step} order={order} role={role} autoplayInterlude={autoplayInterlude} onSelect={chooseRole} onNext={next} onRestart={restart} onDarken={setInterludeDark} data-id="element-81" data-mp="1nxgwn80s94yd" />
        </motion.div>
      </AnimatePresence>
    </SnakShell>;
}